export default __webpack_public_path__ + "static/media/img_step_lucia06_m.3d1b4505.jpg";